import React from "react";
import ButtonMaterial from "@material-ui/core/Button";
// import { history } from "utils/hist.js";
import ReactSVG from "react-svg";
// nodejs library that concatenates classes
// import classNames from "classnames";
//react-select
// import _ from 'lodash'
// @material-ui/core components
// import { withStyles } from "@material-ui/core/styles";

import ImageZoom from "react-medium-image-zoom";
// core components
// import Header from "components/Header/Header.jsx";
// import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
// import HeaderLinks from "components/Header/HeaderLinks.jsx";
// import Parallax from "components/Parallax/Parallax.jsx";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardFooter from "components/Card/CardFooter";
import Button from "../../components/CustomButtons/Button";
// import IconButton from '@material-ui/core/IconButton';
// import profilePageStyle from "assets/jss/material-kit-react/views/profilePage.jsx";
import "./ProfilePage.css";
import attention from "../../components/Icons/attention.svg";
//redux
//const EndUser = require('./eusign')
//redux
import { connect } from "react-redux";
import { setPaymant, getPaymant } from "redux/actions/agrimantActions";
import imageLoader from "../../components/Icons/loading.png";
import {
  // deletePaymantScan,
  savePaymantScan
} from "api/api";
// import {isEmpty} from '../../validation/is-empty'

import uploadTable from "../../components/Icons/download.svg";
// import visibleTable from '../../components/Icons/visible.svg'
// import deleteTable from '../../components/Icons/close.svg'
// import { CardActions } from "@material-ui/core";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import EndUser from "utils/eusign";
import axios from "axios";
// import EusignView from "./ModelView/EusignModal";

const MySwal = withReactContent(Swal);
const swalWithBootstrapButtons = MySwal.mixin({
  confirmButtonColor: "#2D5CA6",
  cancelButtonColor: "#FF0000",
  customClass: {
    confirmButton: "br0 ",
    cancelButton: "br0 mr-3"
  },
  buttonsStyling: true
});

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000
});
const BASE64_MARKER = ";base64,";
function convertDataURIToBinary(dataURI) {
  var base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
  var base64 = dataURI.substring(base64Index);
  var raw = window.atob(base64);
  var rawLength = raw.length;
  var array = new Uint8Array(new ArrayBuffer(rawLength));

  for (let i = 0; i < rawLength; i++) {
    array[i] = raw.charCodeAt(i);
  }
  return array;
}

class Paymants extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "someUniqueId", // I would use this.props.id for a real world implementation
      imageURI: null,
      fileName: "",
      //euSign: null,
      addPaymantBtn: false,
      openEusign: false,
      submitted: false
    };
    this.fileInputPaymant = React.createRef();
  }
  handlBack = () => {
    this.props.onClose();
  };

  opneEusignModal = () => {
    this.setState({ openEusign: true });
  };

  buildImgTag() {
    let imgTag = null;
    if (this.state.imageURI !== null)
      imgTag = (
        <div className="row">
          <div className="small-9 small-centered columns mt-3">
            <ImageZoom
              defaultStyles={{
                zoomContainer: {
                  zIndex: 1300
                },
                overlay: {
                  opacity: 0.7,
                  backgroundColor: "#000"
                }
              }}
              image={{
                src: this.state.imageURI,
                style: { width: "5em", marginTop: "20px" }
              }}
              zoomImage={{
                src: this.state.imageURI
              }}
            />
          </div>
        </div>
      );
    return imgTag;
  }

  readURI(e) {
    this.setState({ imageURI: "", fileName: e.target.files[0].name });
    // console.log(e.target.files[0].name)
    if (e.target.files && e.target.files[0]) {
      let reader = new FileReader();
      reader.onload = function(ev) {
        // console.log(ev);
        this.setState({ imageURI: ev.target.result });
      }.bind(this);
      reader.readAsDataURL(e.target.files[0]);
    }
  }

  onSign = () => {
    this.setState({ addPaymantBtn: false });
    var previousSign = null;
    var external = false;
    var asBase64String = true;
    var signAlgo = EndUser.SignAlgo.DSTU4145WithGOST34311;
    var signType = 16;

    //console.log(array)
    var BASE64_MARKER = ";base64,";

    // console.log(this.state.euSign)

    this.props.eusign
      .SignData(
        convertDataURIToBinary(this.state.imageURI),
        external,
        asBase64String,
        signAlgo,
        null,
        signType
      )
      .then(sign => {
        //document.getElementById('textAreaSign').value = sign;
        this.setState({ addPaymantBtn: true });
        // console.log(sign);
        axios
          .post("/mothers/Save", { sign })
          .then(resp => {
            // console.log(resp);
          })
          .catch(err => {
            // console.log(err);
          });
      })
      .catch(e => {
        Toast.fire({
          type: "error",
          title:
            "Виникла помилка при підписі даних. " +
            "Опис помилки: " +
            (e.message || e)
        });
        // alert('Виникла помилка при підписі даних. ' +
        // 	'Опис помилки: ' + (e.message || e));
      });
  };

  handleSubmit = event => {
    event.preventDefault();
    this.setState({ submitted: true });
    // console.log(this.state.submitted)
    var formData = new FormData();

    formData.append("file", this.fileInputPaymant.current.files[0]);

    // console.log(this.props.euSign)

    var previousSign = null;
    var external = false;
    var asBase64String = true;
    var signAlgo = EndUser.SignAlgo.DSTU4145WithGOST34311;
    var signType = 16;

    this.props.eusign
      .SignData(
        convertDataURIToBinary(this.state.imageURI),
        external,
        asBase64String,
        signAlgo,
        null,
        signType
      )
      .then(sign => {
        //document.getElementById('textAreaSign').value = sign;
        this.setState({ addPaymantBtn: true });

        // console.log(sign);
        const paymantRow = {
          agreement_id: 0,
          applicant_id: 0,
          c_scanname: this.state.fileName,
          i_agreement: 0,
          id: 0,
          l_fix: null,
          l_match: null,
          n_date: "",
          n_source: 0,
          n_sum: null,
          sum_compense: null,
          file: this.state.imageURI,
          sign: sign
        };

        const paymatWithFile = this.props.paymants.concat(paymantRow);
        this.props.setPaymant(paymatWithFile);
        this.setState({ submitted: false });
      })
      .catch(e => {
        Toast.fire({
          type: "error",
          title:
            "Виникла помилка при підписі даних. " +
            "Опис помилки: " +
            (e.message || e)
        });
        this.setState({ submitted: false });
        // alert('Виникла помилка при підписі даних. ' +
        // 	'Опис помилки: ' + (e.message || e));
      });
  };

  savePaymantOnServer = (e, sign) => {
    //console.log(file);
    swalWithBootstrapButtons
      .fire({
        title: "Ви впевнені?",
        showCancelButton: true,
        confirmButtonText: "Так, відправити",
        cancelButtonText: "Ні, відмінити!",
        reverseButtons: true,
        showLoaderOnConfirm: true
      })
      .then(result => {
        if (result.value) {
          const format = this.state.fileName.split(".");
          const data = {
            id: 0,
            idAgr: this.props.idAgreemant,
            sign: sign,
            format: format[format.length - 1]
          };
          savePaymantScan(data)
            .then(resp => {
              //this.setState({imageURI : null})
              swalWithBootstrapButtons.fire("Платіж відправлено в УПСЗН!");
              this.setState({ fileName: "", addPaymantBtn: false });
              this.props.getPaymant(this.props.idAgreemant, 0);
            })
            .catch(err => {
              //console.log("payments doesn t send",err)
              //this.setState({fileName: '', addPaymantBtn: false})
              if (err.response.status === 400) {
                swalWithBootstrapButtons.fire({
                  text: err.response.data
                });
              } else {
                swalWithBootstrapButtons.fire({
                  text: "Сталася помилка!"
                });
              }
            });
        }
      });
  };

  handleDelete = (e, id, index) => {
    let temp = [...this.props.paymants];
    temp.splice(index, 1);
    this.props.setPaymant(temp);
    // deletePaymantScan(id)
    // .then(resp => {
    //   this.props.getPaymant(this.props.match.params.id, 0)
    // })
    // .catch(err => {

    // })
  };

  handleChange(e) {
    this.readURI(e); // maybe call this with webworker or async library?
    if (this.props.onChange !== undefined) this.props.onChange(e); // propagate to parent component
    //console.log("e",e)
  }
  onClose = () => {
    this.setState({ openEusign: false });
  };
  render() {
    const { classes, euSign, ...rest } = this.props;
    const imgTag = this.buildImgTag();
    // console.log(euSign);
    const tablePaymant = this.props.paymants.map((item, index) => {
      return (
        <tr key={item.id}>
          <td>{index + 1}</td>
          <td>{item.n_date}</td>
          <td>{item.n_sum}</td>
          <td>{item.sum_compense}</td>

          <td>
            <a href={`mothers/file/${item.c_scanname}`} download>
              {item.c_scanname}
            </a>
          </td>
          <td>
            {" "}
            <div>
              <ButtonMaterial
                size="small"
                color="primary"
                variant="contained"
                disabled={item.id !== 0}
                onClick={e => this.handleDelete(e, item.id, index)}
              >
                видалити
              </ButtonMaterial>
            </div>
          </td>

          <td>
            {" "}
            <div>
              <ButtonMaterial
                size="small"
                color="primary"
                variant="contained"
                disabled={item.id !== 0}
                onClick={e => this.savePaymantOnServer(e, item.sign)}
              >
                Відправити
              </ButtonMaterial>
            </div>
          </td>
        </tr>
      );
    });

    return (
      <div>
        {/* <Header
          color="transparent"
          brand="EGAP"
          rightLinks={<HeaderLinks />}
          fixed
          changeColorOnScroll={{
            height: 100,
            color: "white"
          }}
          {...rest}
        />
        <Parallax small filter image={require("../../assets/img/profile-bg.jpg")} /> */}
        {/* <div className={classNames(classes.main, classes.mainRaised)}> */}
        <div>
          <GridContainer justify="flex-start">
            <GridItem xs={12}>
              <div>
                <div>
                  <div>
                    {/* //for Large  devices */}
                    <Card plain className="tableLargeScreen  ">
                      <CardBody className="cardBody">
                        {/* <h4 className="text-left ml-2 mb-2">Платежі</h4> */}
                        <div className="container-fluid">
                          {this.props.paymants.length > 0 && (
                            <table>
                              <thead>
                                <tr>
                                  <th>№з.п</th>
                                  <th style={{ width: "30%" }}>Дата</th>
                                  <th style={{ width: "20%" }}>Сума</th>
                                  <th style={{ width: "20%" }}>
                                    Компенсація послуги
                                  </th>
                                  <th>Скан</th>
                                  <th>Видалити</th>
                                  <th>Відправити</th>
                                </tr>
                              </thead>
                              <tbody>{tablePaymant}</tbody>
                            </table>
                          )}
                          <form onSubmit={this.handleSubmit}>
                            <div className="mt-3">{this.state.fileName}</div>
                            <label
                              htmlFor="file-upload"
                              className="custom-file-upload mr-md-3 btn100"
                            >
                              <div
                                style={{
                                  margin: "0 auto",
                                  textAlign: "center"
                                }}
                              >
                                <div
                                  style={{
                                    display: "inline-block",
                                    textAlign: "center"
                                  }}
                                >
                                  <ReactSVG
                                    svgStyle={{
                                      display: "inline-block",
                                      height: 33
                                    }}
                                    src={uploadTable}
                                    width="50"
                                  />
                                </div>

                                <div
                                  style={{
                                    display: "inline-block",
                                    textAlign: "center"
                                  }}
                                >
                                  ОБЕРІТЬ ФАЙЛ
                                </div>
                              </div>
                            </label>
                            {this.state.submitted && (
                              <div className="text-center">
                                <i
                                  className="winphone-2-128x6"
                                  style={{
                                    backgroundImage: "url(" + imageLoader + ")"
                                  }}
                                />
                              </div>
                            )}
                            {/* <input type="file" accept='.p7s'  onChange={this.handleChange.bind(this)} id="file-upload" className="upload" ref={this.fileInputPaymant}/> */}
                            <input
                              type="file"
                              accept=".png,.jpeg,.jpg,.pdf"
                              onChange={this.handleChange.bind(this)}
                              id="file-upload"
                              className="upload"
                              ref={this.fileInputPaymant}
                            />

                            <div className="mb-2">
                              <ReactSVG
                                svgStyle={{
                                  display: "inline-block",
                                  height: 33
                                }}
                                src={attention}
                                width="50"
                              />
                              <div
                                style={{
                                  display: "inline-block",
                                  textAlign: "center"
                                }}
                              >
                                Увага! Необхідно накласти КЕП на сканований
                                документ!
                              </div>
                              <div
                                style={{
                                  display: "inline-block",
                                  textAlign: "center"
                                }}
                              >
                                Увага! Розмір документу для завантаження не
                                повинен перевищувати 6 МB
                              </div>
                            </div>
                            {/* <Button color="primary" variant="contained" onClick={this.init}>Підпис файла</Button> */}
                            {/* <div id="sign-widget-parent" style={{width:"700px", height:"500px"}}/> */}
                            {/* <Button
              color="primary"
              variant="contained"
              className="d-inline-block btn100 mr-3"onClick={this.onSign}>Підписати файл</Button> */}
                            {this.state.imageURI && (
                              <Button
                                color="primary"
                                variant="contained"
                                type="submit"
                                className="d-inline-block btn100 mr-3"
                              >
                                Додати платіж
                              </Button>
                            )}
                          </form>
                        </div>
                        {/* </div> */}
                      </CardBody>
                      {/* <CardFooter
                        style={{ marginLeft: "auto", marginRight: "auto" }}
                      > */}
                        {/* <EusignView openEusign={this.state.openEusign} onClose={this.onClose}/> */}

                        {/* <Button onClick={this.opneEusignModal}>Open Modal</Button> */}

                        {/* <Button
                          color="primary"
                          className="d-inline-block  ml-md-4 btn100 br0"
                          variant="contained"
                          onClick={this.handlBack}
                        >
                          {" "}
                          Вихід{" "}
                        </Button> */}
                      {/* </CardFooter> */}
                    </Card>
                  </div>
                </div>
              </div>
            </GridItem>
          </GridContainer>
        </div>
        {/* </div> */}
        {/* <Footer /> */}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    mainID: state.applicant.mainID,
    id: state.applicant.id,
    //agrimantID: state.agrimant.agrimants,
    applicant: state.applicant,
    addressFact: state.applicant.adressfact,
    addressReg: state.applicant.adressreg,
    directories: state.directories,
    children: state.children.data,
    application: state.application,
    paymants: state.agrimant.paymants,
    euSign: state.eusign.eusign
  };
};

export default connect(
  mapStateToProps,
  {
    setPaymant,
    getPaymant
  }
)(Paymants);
